export function tryParseArrayInput(raw: string): unknown[] | null {
  const trimmed = raw.trim()
  if (trimmed.length === 0) return []

  if (trimmed.startsWith('[')) {
    try {
      const parsed = JSON.parse(trimmed)
      if (Array.isArray(parsed)) return parsed
    } catch {
      /* fall through */
    }
  }

  return trimmed.split(',').map((item) => {
    const t = item.trim()
    if ((t.startsWith('"') && t.endsWith('"')) || (t.startsWith("'") && t.endsWith("'"))) {
      return t.slice(1, -1)
    }
    const asNumber = Number(t)
    if (!Number.isNaN(asNumber) && t !== '') return asNumber
    if (t === 'true') return true
    if (t === 'false') return false
    if (t === 'null') return null
    return t
  })
}
